import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import { format, subDays } from "date-fns";
import { withRouter } from "react-router";

import { Button } from "@lifepay/rc-ui-toolkit";

// import Labeled from "components/visual/Labeled";
// import Details from "components/visual/Details";

import styles from "./Terminal.m.scss";

function Terminal(props) {
  const { theme, item, history, basePath } = props;

  return (
    <div className={classnames(theme.wrapper)}>
      <div className={classnames(theme.summary)}>
        <div>{item.id}</div>
        <div>{item.merchantId}</div>
        <div>{item.merchantName}</div>
        <div>
          {item.lastTransactionDate
            ? format(item.lastTransactionDate, "YYYY/MM/DD HH:mm:ss")
            : "-"}
        </div>
        <div>
          {item.lastSuccessTransactionDate
            ? format(item.lastSuccessTransactionDate, "YYYY/MM/DD HH:mm:ss")
            : "-"}
        </div>
        <div>{item.mmc}</div>
        <div>{item.hasChip ? "✓" : "❌"}</div>
        <div>
          <Button
            theme={{ wrapper: theme.button }}
            size={"small"}
            type={"alt"}
            onClick={() => {
              history.push({
                pathname: `${basePath}/transactions`,
                search: `?terminal-id=${item.id}`,
                state: {
                  useRouterState: true,
                  routerStateQuery: {
                    terminalId: item.id,
                    dateTo: new Date(),
                    dateFrom: subDays(new Date(), 7),
                  },
                },
              });
            }}
          >
            {"Транзакции"}
          </Button>
        </div>
      </div>
    </div>
  );
}

Terminal.displayName = "Terminal";

Terminal.propTypes = {
  theme: PropTypes.object,
  item: PropTypes.object,
  history: PropTypes.object,
  basePath: PropTypes.string,
};

Terminal.defaultProps = {};

export default withRouter(themr("@lifepay/Terminal", styles)(Terminal));



// WEBPACK FOOTER //
// ./src/components/list-items/Terminal/Terminal.js